<button mat-icon-button *ngIf="title" class="router-title-button" (click)="reloadUrl()">
  <div class="router-title">{{ title }}</div>
</button>
<div *ngIf="personalizeActive" class="flex-row">
  <div>
    <button mat-icon-button [matMenuTriggerFor]="pageTitleMenu" class="page-title-menu-button"
      aria-label="Vælg gemt visning">
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
  </div>
  <div class="e-chip-list">
    <div *ngFor="let view of primaryMenuItems; trackBy: trackViewMenuItem;"
      [ngClass]="view.isSelected ? 'e-success' : 'e-info'" class="e-chip e-chip-wide">
      <div *ngIf="!view.isSelected" (click)="clickedViewMenu(view)" class="e-chip-text">{{view.name}}</div>
      <div *ngIf="view.isSelected" class="cer-disabled e-chip-text">{{view.name}}</div>
    </div>
  </div>
  <mat-menu #pageTitleMenu="matMenu" xPosition="before">
    <button mat-menu-item *ngFor="let menuItem of viewMenuItems; trackBy: trackViewMenuItem"
      (click)="clickedViewMenu(menuItem)"
      [ngClass]="menuItem.separator ? 'cer-mat-menu-item-separator' : ''">
      <mat-icon>{{ menuItem.icon }}</mat-icon>
      <span>{{ menuItem.text }}</span>
    </button>
  </mat-menu>
</div>
<span [class.hidden]="progressHidden" [class.pageIsLoading]="!progressHidden">
  <div role="progressbar" [class]="progressBarClasses" [attr.aria-valuenow]="progressValue" aria-valuemin="0"
    [attr.aria-valuemax]="progressValueMax" [style]="progressValueStyle"></div>
  <span role="status">{{ progressText }}</span>
</span>